<template>
<div>
    <!-- <div class="d-flex justify-space-between mb-2">
        <div class="d-flex justify-center align-center">
            <div class="img_title_buffet_manage">
                <img src="@/assets/fried-chicken.png">
            </div>
            <h2 class="title_buffet_manage">จัดการบุฟเฟ่ต์</h2>
        </div>
        <v-btn color="#28ab28" class="white--text like_back_title_buffet_manage" height="50" width="20%" @click="$router.push('/restaurant')">
            ย้อนกลับ
        </v-btn>
    </div> -->
    <MenuManageFood />
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show === true">เปลี่ยนสถานะเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_add === true">เพิ่มบุฟเฟ่ต์เรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_edit === true">แก้ไขบุฟเฟ่ต์เรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="d-flex justify-space-between card_buffet_manage">

            <div class="mr-1">
                <v-form ref="form" @submit.prevent="addBuffet()">
                    <div class="mb-2">
                        <h3>{{ edit_id !== null ? 'แก้ไข' : 'เพิ่ม'}}บุฟเฟ่ต์</h3>
                    </div>
                    <v-text-field label="ชื่อรายการบุฟเฟ่ต์ (ภาษาไทย)" v-model="name" :rules="[v => !!v || 'กรุณากรอกชื่อรายการบุฟเฟ่ต์ (ภาษาไทย)']" required outlined></v-text-field>
                    <v-text-field label="ชื่อรายการบุฟเฟ่ต์ (ภาษาอังกฤษ)" v-model="name_eng" :rules="[v => !!v || 'กรุณากรอกชื่อรายการบุฟเฟ่ต์ (ภาษาอังกฤษ)']" required outlined></v-text-field>
                    <v-text-field label="ราคาต่อท่าน" v-model="price" :rules="[v => !!v || 'กรุณากรอกราคาต่อท่าน']" type="number" required outlined></v-text-field>
                    <v-btn color="#28ab28" class="white--text titlefont_buffet_manage" width="100%" height="50" type="submit">
                        บันทึก
                    </v-btn>
                </v-form>
            </div>
            <div class="ml-1">
                <v-card>
                    <v-card-title>
                        <v-text-field v-model="search" color="primary" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="data" :search="search">
                        <template v-slot:item="dataDetail">
                            <tr>
                                <td>{{dataDetail.item.number}}</td>
                                <td>{{dataDetail.item.name}}</td>
                                <td>{{dataDetail.item.name_eng}}</td>
                                <td>{{dataDetail.item.price}}</td>
                                <td>
                                    <span>
                                        <v-switch color="success" v-model="dataDetail.item.status" @click="changeStatus(dataDetail.item.id)"></v-switch>
                                    </span>
                                </td>
                                <td>

                                    <span class="edit_data_buffet_manage" @click="detailBuffet(dataDetail.item.id)">
                                        <v-icon dark right color="grey">mdi-pencil-box-outline</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import MenuManageFood from '@/components/menuadmin/MenuManageFood.vue'
export default {
    name: 'buffetManage',
        components: {
        MenuManageFood,
    },
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            alert_show: false,
            alert_show_add: false,
            alert_show_edit: false,
            search: '',
            headers: [{
                    text: '#',
                    align: 'start',
                    value: 'number',
                },

                {
                    text: 'ชื่อรายการ (ไทย)',
                    value: 'name'
                },
                {
                    text: 'ชื่อรายการ (อังกฤษ)',
                    value: 'name_eng'
                },
                {
                    text: 'ราคาต่อท่าน',
                    value: 'price'
                },
                {
                    text: 'สถานะ',
                    value: 'status'
                },
                {
                    text: 'จัดการ',
                    value: 'action'
                },
            ],
            data: [],
            edit_id: null,
            name: null,
            name_eng:null,
            price: null,
        }
    },
    methods: {
        async buffetList() {
            this.loading_page = true
            HTTP.get('/buffet/list', {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        for (let index = 0; index < response.data.list.length; index++) {
                            response.data.list[index].number = index + 1
                        }
                        this.data = response.data.list
                        this.loading_page = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async changeStatus(id) {
            HTTP.post('/buffet/status-update', {
                    id: id
                }, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.alert_show = true
                        setTimeout(() => this.alert_show = false, 5000)
                    }

                })
                .catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async detailBuffet(id) {
            HTTP.get('/buffet/get-old/' + id, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.edit_id = response.data.buffet_detail.id
                        this.name = response.data.buffet_detail.name
                        this.name_eng = response.data.buffet_detail.name_eng
                        this.price = response.data.buffet_detail.price
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async addBuffet() {
 
            if (this.$refs.form.validate()) {
                this.loading_page = true
                if (this.edit_id === null) {
                    HTTP.post('/buffet/create', {
                            name: this.name,
                            name_eng: this.name_eng,
                            price: this.price
                        }, {
                            headers: {
                                "Authorization": `Bearer ${this.$store.state.token}`
                            }
                        })
                        .then((response) => {
                            if (response.data.successful === true) {
                                this.name = null
                                this.name_eng = null
                                this.price = null
                                this.buffetList()
                                this.alert_show_add = true
                                setTimeout(() => this.alert_show_add = false, 5000)
                            }

                        }).catch((error) => {
                            if (error.response.status === 401) {
                                this.$store.commit('logOutSuccess')
                                this.$router.push('/login')
                            }
                        })

                } else {
                    HTTP.post('/buffet/update', {
                            id: this.edit_id,
                            name: this.name,
                            name_eng: this.name_eng,
                            price: this.price,
                        }, {
                            headers: {
                                "Authorization": `Bearer ${this.$store.state.token}`
                            }
                        })
                        .then((response) => {
                            if (response.data.successful === true) {
                                this.edit_id = null
                                this.name = null
                                this.name_eng = null
                                this.price = null
                                this.buffetList()
                                this.alert_show_edit = true
                                setTimeout(() => this.alert_show_edit = false, 5000)
                            }

                        }).catch((error) => {
                            if (error.response.status === 401) {
                                this.$store.commit('logOutSuccess')
                                this.$router.push('/login')
                            }
                        })
                }
            }
        }
    },
    mounted() {
        this.buffetList()
    }
}
</script>
